export const StaticTextFields = {
    header: {
        pageName: 'Header',
        list: [
            {
                label: "Header - events",
                key: "header_item_events"
            },
            {
                label: "Header - about",
                key: "header_item_about"
            },
            {
                label: "Header - videos",
                key: "header_item_videos"
            },
            {
                label: "Header - traveling",
                key: "header_item_traveling"
            },
            {
                label: "Header - projects",
                key: "header_item_projects"
            },
            {
                label: "Header - contact",
                key: "header_item_contact"
            },
            {
                label: "Header - menu",
                key: "header_item"
            },
            {
                label: "Header - search placeholder",
                key: "header_search_placeholder"
            },
            {
                label: "Header - search not result",
                key: "header_search_notResult"
            },
            {
                label: "Header - connect",
                key: "header_connect"
            },
        ]
    },
    homepage: {
        pageName: 'Homepage',
        list: [
            {
                label: "Homepage - events title",
                key: "homepage_events_title"
            },
            {
                label: "Homepage - events more",
                key: "homepage_events_more"
            },
            {
                label: "Homepage - main title",
                key: "homepage_main_title"
            },
            {
                label: "Homepage - main description",
                key: "homepage_main_description"
            },
            {
                label: "Homepage - subscribe placeholder",
                key: "homepage_subscribe_placeholder"
            },
            {
                label: "Homepage - subscribe btn",
                key: "homepage_subscribe_btn"
            },
            {
                label: "Homepage -news title",
                key: "homepage_news_title"
            },
            {
                label: "Homepage - news description",
                key: "homepage_news_description"
            },
            {
                label: "Homepage - project title",
                key: "homepage_project_title"
            },
            {
                label: "Homepage - project more",
                key: "homepage_project_more"
            },
            {
                label: "Homepage - travel title",
                key: "homepage_travel_title"
            },
            {
                label: "Homepage - travel more",
                key: "homepage_travel_more"
            },
            {
                label: "Homepage - video title",
                key: "homepage_video_title"
            },
            {
                label: "Homepage - video more",
                key: "homepage_video_more"
            },
        ]
    },
    footer: {
        pageName: 'Footer',
        list: [
            {
                label: "Footer - events title",
                key: "footer_item_events"
            },
            {
                label: "Footer - about title",
                key: "footer_item_about"
            },
            {
                label: "Footer - videos title",
                key: "footer_item_videos"
            },
            {
                label: "Footer - traveling title",
                key: "footer_item_traveling"
            },
            {
                label: "Footer - projects title",
                key: "footer_item_projects"
            },
            {
                label: "Footer - contact title",
                key: "footer_item_contact"
            },
            {
                label: "Footer - social medias",
                key: "footer_social_medias"
            },
            {
                label: "Footer - developed",
                key: "footer_developed"
            },
            {
                label: "Footer - cooperation",
                key: "footer_cooperation"
            },
            {
                label: "Footer - copyright text",
                key: "footer_section_copyright_text"
            },
            {
                label: "Footer - project developed by text",
                key: "footer_section_developed_by_text"
            },
        ]
    },
    about: {
        pageName: 'About',
        list: [
            {
                label: "About - page title",
                key: "about_page_title"
            },
            {
                label: "About - page description",
                key: "about_page_description"
            },
            {
                label: "About - page subtitle",
                key: "about_page_subtitle"
            },
            {
                label: "About - page years count",
                key: "about_page_years_count"
            },
            {
                label: "About - page years title",
                key: "about_page_years_title"
            },
            {
                label: "About - page project count",
                key: "about_page_project_count"
            },
            {
                label: "About - page project title",
                key: "about_page_project_title"
            },
        ]
    },
    search: {
        pageName: 'Search',
        list: [
            {
                label: "Search - page title",
                key: "search_page_title"
            },
            {
                label: "Search - page total text",
                key: "search_page_total"
            },
            {
                label: "Search - page not result",
                key: "search_page_notResult"
            },
        ]
    },
    blog: {
        pageName: 'Blog',
        list: [
            {
                label: "Blog - share title",
                key: "blog_share_title"
            },
            {
                label: "Blog - video title",
                key: "blog_title_VIDEO"
            },
            {
                label: "Blog - video  description",
                key: "blog_description_VIDEO"
            },
            {
                label: "Blog - traveling title",
                key: "blog_title_TRAVELING"
            },
            {
                label: "Blog - traveling  description",
                key: "blog_description_TRAVELING"
            },
            {
                label: "Blog - project title",
                key: "blog_title_PROJECT"
            },
            {
                label: "Blog - project  description",
                key: "blog_description_PROJECT"
            },
            {
                label: "Blog - event title",
                key: "blog_title_EVENT"
            },
            {
                label: "Blog - event  description",
                key: "blog_description_EVENT"
            },
            {
                label: "Blog - slider title",
                key: "blog_slider_title"
            },
        ]
    },
    contacts: {
        pageName: 'Contacts',
        list: [
            {
                label: "Contacts - page title",
                key: "contact_page_title"
            },
            {
                label: "Contacts - page description",
                key: "contact_page_description"
            },
            {
                label: "Contacts - inputs title",
                key: "contact_page_inputs_title"
            },
            {
                label: "Contacts - inputs description",
                key: "contact_page_inputs_description"
            },
            {
                label: "Contacts - social text",
                key: "contact_page_social_text"
            },
            {
                label: "Contacts - Page placeholder name",
                key: "contacts_page_placeholder_name"
            },
            {
                label: "Contacts - Page label name",
                key: "contacts_page_label_name"
            },
            {
                label: "Contacts - Page placeholder lastName",
                key: "contacts_page_placeholder_lastName"
            },
            {
                label: "Contacts - Page label lastName",
                key: "contacts_page_label_lastName"
            },
            {
                label: "Contacts - Page placeholder email",
                key: "contacts_page_placeholder_email"
            },
            {
                label: "Contacts - Page label email",
                key: "contacts_page_label_email"
            },
            {
                label: "Contacts - Page placeholder phoneNumber",
                key: "contacts_page_placeholder_phoneNumber"
            },
            {
                label: "Contacts - Page label phoneNumber",
                key: "contacts_page_label_phoneNumber"
            },
            {
                label: "Contacts - Page placeholder message",
                key: "contacts_page_placeholder_message"
            },
            {
                label: "Contacts - Page label message",
                key: "contacts_page_label_message"
            },
            {
                label: "Contacts - Page btn send",
                key: "contacts_page_btn_send"
            },
        ]
    },
    badges: {
        pageName: 'Badges',
        list: [
            {
                label: "Badge - Event",
                key: "badge_event"
            },
            {
                label: "Badge - Project",
                key: "badge_project"
            },
            {
                label: "Badge - Traveling",
                key: "badge_traveling"
            },
            {
                label: "Badge - Video",
                key: "badge_video"
            },
        ]
    },
}